<template>
  <div class="container-fluid login">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info">
        <div class="logo">
          <a :href="lpUrl" class="ico-iouu" target="_blank" title="IOUU"></a>
        </div>
        <div class="row justify-content-center d-flex align-items-center">
          <div class="col-12 col-lg-10 d-flex flex-column align-items-center">
          <h1>Crie sua conta</h1>
            <p>
              Não se preocupe. Você não está assumindo nenhum compromisso neste momento.
              <br/>Suas informações serão usadas apenas para analisarmos o seu perfil
            </p>
            <p>
              Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.
            </p>
          </div> 
        </div>
        <social-network/>
      </div>
      <div class="col-12 col-md-12 col-lg-7 d-flex flex-column form" >
        <header class="align-self-center align-self-md-end">
        Já tem uma conta?
          <router-link to="login" class="btn btn-outline-primary">Entrar</router-link>
        </header>
        <div class="row justify-content-center d-flex align-items-center" v-if="visivel">
          <div class="col-12 col-md-8 col-lg-5 text-center">
            <h2>Criar uma conta</h2>
            <div class="btn-group btn-group-justified align-self-center " role="group" aria-label="Large button group">
              <!--<button @click="facebookLogin" class="btn btn-lg btn-secondary facebook"><i class="fab fa-facebook-f"></i> <span>Facebook</span></button>
              <button @click="googleLogin" class="btn btn-lg btn-secondary google"><i class="fab fa-google"></i> <span>Google</span></button>
              <button @click="linkedinLogin" class="btn btn-lg btn-secondary linkedin"><i class="fab fa-linkedin-in"></i> <span>Linkedin</span></button> -->
            </div>
            <!--<span class="other">ou</span> -->
            <form id="form-criarConta" @submit.prevent="signUp">
              <div class="form-group text-left">
                <label for="name">Nome</label>
                <input type="text" name="firtname" @keyup="validateName()" class="form-control form-control-lg" v-model="name" autofocus>
              </div>
              <div class="form-group text-left">
                <label for="email">Endereço de email</label>
                <input v-on:focusout="ValidarEmail" v-on:focusin="RetirarAnimacao" type="email" class="form-control form-control-lg" id="Email" v-model="email">
                <div class="validacao">
                  <i hidden id="IconeInvalido" class="invalido fas fa-exclamation-circle"></i>
                  <i hidden id="IconeValido"   class="valido fas fa-check"></i>              
                </div>

              </div>
              <div class="form-group text-left">
                <label for="password">Senha</label> 
                <password-field v-model="password"/>
              </div>

              <div class="form-check text-left d-flex justify-content-center">
                <div class="checkboxContainer">
                  <input class="form-check-input" type="checkbox" v-model="enabled">
                  <span class="checkmark"></span>
                </div>
                <label class="form-check-label p-0">
                  Eu "CONCORDO" com os <a :href="lpUrl+'/termos-e-condicoes/'" target="_blank">Termos e condições</a> e <a :href="lpUrl+'/politica-de-privacidade/'" target="_blank">Política de privacidade</a> da IOUU.
                </label>
              </div>
                <button class="btn btn-lg btn-primary" :disabled="!enabled || !EmailConfirmado">Continuar</button>
            </form>
          </div>
        </div>

		<div class="row justify-content-center d-flex align-items-center aviso" v-if="!visivel">
			<div class="col-12 col-md-10 col-lg-8 text-center">
				<h2>Qual perfil deseja criar?</h2>
				<div class="align-self-center">
					<a :href="'https://emprestimos.iouu.com.br/pedido'" class="btn btn-lg btn-primary"> <span>Empréstimo</span></a>
          <router-link class="login" to="/criar-conta">
            	<button class="btn btn-lg btn-primary"> <span>Investimento</span></button>
          </router-link>
				</div>
			</div>
		</div>

      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/styles/iouu/variables";
@import "../assets/styles/iouu/mixins";

  .form-check-label {
    &.p-0 {
      & {
        padding-left: 0;
      }
    }
  }

  .aviso {
	  h2 {
		  padding-bottom: 30px;

		  @include xs {
			  @include font-size(25px);
			  padding-bottom: 40px;
		  }
	  }
	  .btn-primary {
		border-color: #888;
		background: #fff;
		@include font-size(18px);
		margin: 0 10px;
		text-transform: uppercase;
		line-height: 55px;
		padding: 0px 55px;
		font-weight: bold;


		@include xs {
			@include font-size(15px);
			line-height: 40px;
			width: 80%;
			margin-bottom: 10px;
		}
		
		span {
			color: #999;
		}

		&:hover {
			border-color: $c3;
			background: $c3;

			span {
				color: #fff;
			}
		}
	  }
  }
  // CHECKBOX - CUSTOM 
	.checkboxContainer {
		&{
		  display: block;
		  position: relative;
		  cursor: pointer;
		  -webkit-user-select: none;
		  -moz-user-select: none;
		  -ms-user-select: none;
			user-select: none;
			width: 25px;
			height: 25px;
			margin-right: 10px;
    }
    
		&:hover {
		  input ~ .checkmark {
			background-color: #ccc;
		  }
		}
	
		input {
		  position: absolute !important;
		  opacity: 0;
		  width: 25px;
		  height: 25px;
		  cursor: pointer;
			left: 0;
      margin-left: 0;
      top: -4px;
	
		  &:checked ~ .checkmark {
			background-color: #41D3BF;
		  }
		}
	
		.checkmark {
		  position: absolute;
		  top: -4px;
		  left: 0;
		  height: 25px;
		  width: 25px;
		  background-color: #eee;
		  border-radius: 6px;
		  cursor: pointer;
		  pointer-events: none;
	
		  &::after {
			content: "";
			position: absolute;
			display: none;
			left: 9px;
			top: 5px;
			width: 8px;
			height: 13px;
			border: solid white;
			border-width: 0 3px 3px 0;
			-webkit-transform: rotate(45deg);
			-ms-transform: rotate(45deg);
			transform: rotate(45deg);
		  }
	
		}
	
		input:checked ~ .checkmark:after {
		  display: block;
		}
	}
	// END CHECKBOX - CUSTOM


  .login {
    .info {
      background:url(/static/assets/images/bg-login.jpg) top center no-repeat, linear-gradient(to bottom right, $c3, $c2 85%);
      background-size: cover;
      // background-blend-mode: multiply;
      text-align: center;
      color: #fff;
    }
  }

</style>


<script>
/* eslint-disable */
import ApiClient from '../utils/api-client'
import SocialNetwork from '../components/SocialNetwork'
import ArrayHelper from '@/utils/array-helper'
import PasswordField from '@/components/PasswordField'
import HubConsultaClient from '@/utils/hub-consulta-client.js'
// import MarketingDrip from '../services/api/marketing';

export default {
  data() {
    return {
      lpUrl:process.env.LP_URL,
      name: '',
      email: '',
      password: '',
      enabled: false,
      visivel:false,
      EmailConfirmado:false,
    }
  },
  components: {
    SocialNetwork, PasswordField
  },
  methods: {
    passwordIsValid() {

      if(this.password.length < 6) {

        this.$Notify.error("A senha deve conter mais de 6 digitos!")
        $("#inputPassword").addClass("animated shake")
        $("#inputPassword").addClass("emailinvalido")

        return false

      }

      else {
        $("#inputPassword").removeClass("animated")
        $("#inputPassword").removeClass("shake")
        $("#inputPassword").removeClass("emailinvalido")

        return true
      }

    },

    linkEmprestimo(){
      this.$router.push("https://emprestimos.iouu.com.br/pedido")
    },
    validateName() {
      if(this.name[0] == " ") {
        this.name = "";
        return;
      } 
      
      var splitText = this.name.split(' ');
      var upperCaseText = '';

      for(var i = 0; i < splitText.length; i++) {
        if(splitText[i] != "") {
            if(i > 0)
            upperCaseText += " ";

          upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
        }
        else if(i > 0)
          upperCaseText += " ";
      }

      this.name = upperCaseText;
    },
    ValidarEmail: function () { 
      //Chama API que faz a Pré Validação do Email para verificar se a ortografia esta correta
      if(this.email != "") {

        this.email = this.email.toLowerCase().trim();
        
         HubConsultaClient.PreValidacaoEmail(this.email)
        .then(resposta => {

          //Sintaxe do Email Inválida
          if(resposta.Msg == "Email Inválido") {
            $("#IconeInvalido").removeAttr("hidden")
            $("#Email").addClass("animated shake")
            $("#Email").addClass("emailinvalido")
            $("#IconeInvalido").addClass("animated shake")
            this.EmailConfirmado = false
            this.$Notify.error("Digite um email válido!")
          }

          //Sintaxe do Email Correta
          else {
            //Chama API que verifica se este usuário já está cadastrado
            HubConsultaClient.ExisteUsuario(this.email)
            .then(resposta => {
              if(resposta.Msg == "Existe") {
                this.$Notify.info("Esse email já foi cadastrado no sistema!")
                $("#IconeInvalido").removeAttr("hidden")
                $("#Email").addClass("animated shake")
                $("#Email").addClass("emailinvalido")
                $("#IconeInvalido").addClass("animated shake")
                this.EmailConfirmado = false
              } 
              else {
                //Chamar API que faz a validação do Email
                HubConsultaClient.theCheckerPost(this.email)
                .then(resposta => {

                    if(resposta == "Entregável") {
                      //Executa se o email for válido
                      $("#IconeValido").removeAttr("hidden")
                      $("#Email").addClass("emailvalido")
                      this.EmailConfirmado = true
                      this.$Notify.success("Email Validado com Sucesso!")
                    } 

                    if(resposta == "Inválido") {
                      //Executa se o email for inválido
                      $("#IconeInvalido").removeAttr("hidden")
                      $("#Email").addClass("animated shake")
                      $("#Email").addClass("emailinvalido")
                      $("#IconeInvalido").addClass("animated shake")
                      this.EmailConfirmado = false
                      this.$Notify.error("Email Inválido!")
                    }

                })
                .catch(() => {
                  $("#IconeValido").removeAttr("hidden")
                  $("#Email").addClass("emailvalido")
                  this.EmailConfirmado = true
                  this.$Notify.success("Email Validado com Sucesso!")
                });//Fim Validação TheChecker
              }
            })
            .catch(() => {
                  $("#IconeValido").removeAttr("hidden")
                  $("#Email").addClass("emailvalido")
                  this.EmailConfirmado = true
                  this.$Notify.success("Email Validado com Sucesso!")
                }); //Fim Existe Usuário
          }
          
        })
        .catch(() => {
                  $("#IconeValido").removeAttr("hidden")
                  $("#Email").addClass("emailvalido")
                  this.EmailConfirmado = true
                  this.$Notify.success("Email Validado com Sucesso!")
        });//Fim Validação Email
      }
    },
    RetirarAnimacao: function () {
      $("#Email").removeClass("animated")
      $("#Email").removeClass("shake")
      $("#Email").removeClass("emailinvalido")
      $("#Email").removeClass("emailvalido")

      $("#IconeInvalido").removeClass("animated")
      $("#IconeInvalido").removeClass("shake")
      $("#IconeInvalido").attr({"hidden":"hidden"})

      $("#IconeValido").attr({"hidden":"hidden"})
    },
    signUp() {

        if(!this.passwordIsValid()) return 

        // if(process.env.NODE_ENV === "production") {
        //   this.Drip(this.name, this.email)
        //   console.log("DRIP")
        // }

        this.$store.dispatch('signup', {name: this.name, email: this.email, password: this.password})
          .then(() => {
            this.$ga.event('NewUser', 'start', 'Investidor');
            fbq('track', 'Lead');
            this.$router.push("/cadastro-concluido-com-sucesso");
          })
          .catch(error => {
            const errorMessages = error.response.data.errors.map(error => error.detail)
            this.$Notify.error(ArrayHelper.toSentence(errorMessages))
          })

        // CADASTRA CONTATO EM ACTIVE CAMPAIN
        HubConsultaClient.CadastrarActive(this.email)
    
      },
    facebookLogin(e) {
      e.preventDefault()
      ApiClient.get('oauth/facebook/url')
        .then(response => {
          window.location.href = response.data.loginUrl
        })
    },
    googleLogin(e) {
      e.preventDefault()
      ApiClient.get('oauth/google/url')
        .then(response => {
          window.location.href = response.data.loginUrl
        })
    },
    linkedinLogin(e) {
      e.preventDefault()
      ApiClient.get('oauth/linkedin/url')
        .then(response => {
          window.location.href = response.data.loginUrl
        })
    },

    //tagueamento GA
    taggingGA() {
      this.$ga.page({
        page: '/criar-conta',
        title: 'CriarConta',
      })
    },
  },
  async created() {

    if(this.$route.query.name)
      this.name = this.$route.query.name;

    if(this.$route.query.email)
      this.email = this.$route.query.email;

    if(this.$route.query.v)
      this.visivel = true

    //tagueamento GA
    await this.taggingGA();
  }
}
</script>



// WEBPACK FOOTER //
// src/views/CriarConta.vue